import SlimSelect from 'slim-select'
import { splitWords, observeSplitReveal } from '../../assets/js/utils/splitWords'

export default class Contact {
  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')

    this.initSplitTitle()

    if (!this.form) return

    this.mailer = '/wp-content/themes/emile-b/mailer/send-mail.php'

    this.initSlimSelect()
    this.bindCheckboxes()
    this.bindFileInput()
    this.bindSubmit()
  }

  initSplitTitle() {
    const subtitle = this.el.querySelector('.contact--subtitle')
    const title = this.el.querySelector('.contact--title')

    let offset = 0
    if (subtitle) {
      splitWords(subtitle, offset)
      offset += subtitle.querySelectorAll('.tt-word').length
    }
    if (title) splitWords(title, offset)

    observeSplitReveal(this.el)
  }

  initSlimSelect() {
    const select = this.form.querySelector('.contact--select')
    if (!select) return
    new SlimSelect({
      select,
      settings: {
        showSearch: false,
      }
    })
  }

  bindFileInput() {
    const input = this.form.querySelector('.contact--file-input')
    const text = this.form.querySelector('.contact--file-text')
    if (!input || !text) return

    input.addEventListener('change', () => {
      const files = Array.from(input.files)
      text.textContent = files.length
        ? files.map(f => f.name).join(', ')
        : 'Sélectionner vos fichiers'
    })
  }

  bindCheckboxes() {
    this.el.querySelectorAll('.contact--checkbox-container').forEach(container => {
      container.addEventListener('click', () => {
        const checkbox = container.querySelector('.contact--input-checkbox')
        checkbox.checked = !checkbox.checked
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) return

      const formData = new FormData(this.form)

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok')
          return response
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.contact--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }
}
